import { types } from 'mobx-state-tree'
import Expression from '../Expression'
import { InputTemplate } from '../Template'
import { Fill, Layerable, Rectangle, Stroke, Transformable, Typography, Visible, UI, InputStateful } from './shared/props'
import assetViews from './shared/views'
import assetChildTypes from './shared/childTypes'

const AssetType = 'Input'

const model = types
  .model(AssetType, {
    // Entity
    Type: types.literal(AssetType),
    objectId: types.identifier,
    // Asset
    name: types.string,
    children: types.late(assetChildTypes),
    placeholder: types.string,
    value: Expression,
    disabled: Expression,
    template: types.maybeNull(types.reference(InputTemplate)),
    ...Layerable,
    ...Fill,
    ...Stroke,
    ...Typography,
    ...Rectangle,
    ...Visible,
    ...Transformable,
    ...UI,
    ...InputStateful
  })
  .views(assetViews)

export default model
